import SidebarMenu from "./SidebarMenu"

export default SidebarMenu
